export const DEFAULT_BORDER_RADIUS_REM = '0.75rem';

export const DEFAULT_BOX_SHADOW = '0.25rem 0.25rem 0.365rem 0.0625rem rgba(0, 0, 0, 0.1);';
